<template>
  <span>
    <a @click="showModal" :class="'btn btn-sm btn-secondary' + (adjusterIds.length ? '' : ' disabled')">
      <i class="fa fa-fw fa-trash"></i> Remove Adjusters
    </a>

    <modal :id="modalId">

      <template v-slot:header>
        <h4 class="modal-title">Remove Adjusters</h4>
      </template>

      <div class="text-danger text-center">
        <strong>Are you sure you want to remove <strong>{{ adjusterIds.length }}</strong> selected adjuster(s) from the text campaign?</strong>
      </div>

      <template v-slot:footer>
        <button type="button" class="btn btn-white" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>

        <form method="POST" :action="action">
          <input type="hidden" name="_token" :value="$csrf_token">
          <input type="hidden" name="adjuster_ids" :value="adjusterIds">
          <button type="submit" class="btn btn-danger"><i class="fa fa-fw fa-trash"></i> Remove Adjusters</button>
        </form>
      </template>

    </modal>
  </span>
</template>

<script>
import HasModal from "./../mixins/HasModal";
import { mapState } from 'pinia'
import { useTextCampaignAdjusterDataStore } from '../../stores/textCampaignAdjusterData'

export default {
  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      type: String,
      default: 'textCampaignDeleteAdjustersModal'
    },

    // Form action value.
    action: {
      type: String,
      required: true
    },

  },

  /**
   * Computed values
   */
  computed: {
    ...mapState(useTextCampaignAdjusterDataStore, {adjusterIds: 'selectedAdjusterIds'}),
  },
}
</script>
